<template>
  <div class="side-menu">
    <div class="logo">
      <!-- logo图片 -->
      <img v-if="computedLogo" :src="computedLogo" alt="Logo" class="logo-img">
      <!-- 系统名称, 在菜单展开时显示 -->
     <h2 v-show="!isCollapse" class="logo-text">{{ computedName }}</h2>
    </div>
    <el-menu
      :default-active="activeMenu"
      class="el-menu-vertical"
      background-color="#ffffff"
      text-color="#333333"
      active-text-color="#ffffff"
      :collapse="isCollapse"
      router
    >
      <el-menu-item index="/dashboard">
        <el-icon><el-icon-odometer /></el-icon>
        <span>仪表盘</span>
      </el-menu-item>

      <el-menu-item index="/user">
        <el-icon><el-icon-user /></el-icon>
        <span>用户管理</span>
      </el-menu-item>

      <el-menu-item index="/product">
        <el-icon><el-icon-goods /></el-icon>
        <span>产品管理</span>
      </el-menu-item>

      <el-menu-item index="/activity">
        <el-icon><el-icon-data-line /></el-icon>
        <span>动态管理</span>
      </el-menu-item>

      <el-menu-item index="/setting">
        <el-icon><el-icon-setting /></el-icon>
        <span>系统设置</span>
      </el-menu-item>

      <!--
      <el-menu-item index="/setting">
        <el-icon><el-icon-setting /></el-icon>
        <span>系统设置</span>
      </el-menu-item>
      -->
    </el-menu>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { useStore } from 'vuex' // 修复：需要使用 useStore
import { useRoute } from 'vue-router'
import logo from '@/assets/LOGO-TAB.png' // <-- 1. 导入你的logo图片

export default {
  name: 'SideMenu',
  setup () {
    const route = useRoute()
    const store = useStore()
    const isCollapse = ref(false)

    const getApiBaseOrigin = () => {
      const base = process.env.VUE_APP_BASE_API || ''
      if (!base) return window.location.origin
      try {
        return new URL(base, window.location.origin).origin
      } catch (e) {
        return window.location.origin
      }
    }

    const getFullImageUrl = (url) => {
      if (!url) return ''
      if (url.startsWith('http') || url.startsWith('blob:')) {
        return url
      }
      // 兼容 "uploads/xxx" 无前导斜杠
      if (url.startsWith('uploads/')) {
        url = `/${url}`
      }
      // 兼容历史值：/api/uploads/xxx.png
      if (url.startsWith('/api/uploads')) {
        return `${getApiBaseOrigin()}${url.replace(/^\/api/, '')}`
      }
      if (url.startsWith('/uploads')) {
        return `${getApiBaseOrigin()}${url}`
      }
      const baseUrl = process.env.VUE_APP_BASE_API || ''
      return `${baseUrl}${url}`
    }
    // 新增：从 store 派生系统名称和 Logo
    const computedName = computed(() => store.getters.appName || '电子名片')
    const computedLogo = computed(() => {
      const s = store.getters.appLogo
      if (s) return getFullImageUrl(s)
      return logo
    })

    const activeMenu = computed(() => route.path)

    return {
      isCollapse,
      activeMenu,
      computedName,
      computedLogo
    }
  }
}
</script>

<style scoped>
.side-menu {
  width: 210px;
  height: 100%;
  background-color: #ffffff;
  transition: width 0.3s;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-start; /* 改为 flex-start 实现左对齐 */
  color: #333333;
  padding: 10px 20px; /* 增加左侧内边距 */
  border-bottom: 1px solid #f0f0f0;
}

.logo-img {
  max-height: 40px;
  max-width: 40px; /* 给予一个固定的宽度 */
  margin-right: 12px; /* 在logo和文字之间增加间距 */
}

.logo-text {
  color: #333333;
  font-size: 20px; /* 保持和 h2 类似的大小 */
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-menu-vertical {
  border-right: none;
}

.el-menu-vertical:not(.el-menu--collapse) {
  width: 210px;
}

/* 自定义菜单项样式 */
:deep(.el-menu-item) {
  height: 50px;
  line-height: 50px;
  margin: 5px 10px;
  border-radius: 6px;
  width: calc(100% - 20px);
}

:deep(.el-menu-item.is-active) {
  background-color: #000000 !important;
  color: #ffffff;
}

:deep(.el-menu-item:hover) {
  background-color: #f5f5f5 !important;
}

:deep(.el-menu-item.is-active:hover) {
  background-color: #000000 !important;
}
</style>
